/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I reuse a strong password across sites?`)
};

const es_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Debería reutilizar una contraseña fuerte en múltiples sitios?`)
};

const de_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte ich ein starkes Passwort auf mehreren Websites verwenden?`)
};

const nl_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet ik een sterk wachtwoord op meerdere sites gebruiken?`)
};

const fr_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devrais-je réutiliser un mot de passe fort sur plusieurs sites?`)
};

const it_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo riusare una password forte su più siti?`)
};

const pt_br2_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo reutilizar uma senha forte em vários sites?`)
};

const pt_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo reutilizar uma senha forte em vários sites?`)
};

const ja_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数のサイト間で強いパスワードを再利用すべきですか?`)
};

const zh_pw_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我应该在多个网站上重复使用同一个强密码吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_faq4_q", locale)
	if (locale === "en") return en_pw_faq4_q(inputs)
	if (locale === "es") return es_pw_faq4_q(inputs)
	if (locale === "de") return de_pw_faq4_q(inputs)
	if (locale === "nl") return nl_pw_faq4_q(inputs)
	if (locale === "fr") return fr_pw_faq4_q(inputs)
	if (locale === "it") return it_pw_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pw_faq4_q(inputs)
	if (locale === "pt") return pt_pw_faq4_q(inputs)
	if (locale === "ja") return ja_pw_faq4_q(inputs)
	return zh_pw_faq4_q(inputs)
};